import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { lionSelectors } from '@rosetta/react-lion';
import { appActions, appSelectors, TRANSACTION_STATE } from '../../app/reducer/app-reducer';
import {
  appMainBackground,
  appTextColor,
  blueEnabledColor,
  dashboardGoalsBackground,
  defaultBoxShadow,
  mediumGrey,
  warningRedColor,
  white
} from '../../../styles/colors';
import userIcon from '../../../assets/images/user-icon.svg';
import { menuStyle } from '../../../styles/LaunchpadCompactDropdownStyle';
import { LaunchpadButton } from '../../../styles/LaunchpadButton';
import { RSDropdown } from '@rosetta/rs-dropdown';
import { MouseCatcherContainer as MouseCatcher } from '../../app/util/MouseCatcher';
import { passwordChangeActions, passwordChangeSelectors } from '../../login/reducer/password-change-reducer';
import { registerActions, registerSelectors } from '../reducer/register-reducer';
import { InputWithIconContainer as InputWithIcon } from '../../app/util/InputWithIcon';
import { FieldErrorAlert } from '../../../styles/FieldErrorAlert';
import greenCheck from '../../../assets/images/check-solid-green.svg';
import { timezones, validateUserInfo, voiceTypes } from '../../app/util/user-helper';
import { HelpButtonContainer as HelpButton } from '../../app/util/HelpButton';
import { LOGIN_STATUS, authSelectors } from '@rosetta/react-auth';
import { InputAndAlertContainerContainer as InputAndAlertContainer } from '../../app/util/InputAndAlertContainer';
import { withWindowDimensions } from '@rosetta/react-common-ui';
import { isMobile as isMobileDetected } from 'react-device-detect';
import EndInteraction from '../../app/components/EndInteraction';

let isRtl = false;

const widgetWidth = 240;
const widgetHeight = 34;
const widgetWidthMobile = 300;

const RegisterUserDiv = styled.div((props) => {
  let style = {
    position: !props.isMobile ? 'absolute' : 'relative',
    top: '0px',
    bottom: '0px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: appMainBackground
  };

  return style;
});

const RegisterUserBox = styled.div((props) => {
  let style = {
    backgroundColor: !props.isMobile ? white : appMainBackground,
    paddingTop: !props.isMobile ? 30 : 0,
    paddingBottom: !props.isMobile ? 30 : 0,
    width: '100%',
    maxWidth: !props.isMobile ? 600 : 320,
    boxShadow: !props.isMobile ? defaultBoxShadow : 'none',
    borderRadius: '4px'
  };
  return style;
});

const TopContainer = styled.div((props) => {
  let style = {
    display: !props.isMobile ? 'flex' : 'block',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: !props.isMobile ? '0 30px 30px' : '0 10px 10px',
    width: '100%'
  };
  return style;
});

const MiddleContainer = styled.div((props) => {
  let style = {
    display: !props.isMobile ? 'flex' : 'block',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: !props.isMobile ? '0 30px 30px' : '0 10px 10px',
    width: '100%'
  };
  return style;
});

const BottomContainer = styled.div((props) => {
  let style = {
    display: !props.isMobile ? 'flex' : 'block',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: !props.isMobile ? '0 30px 30px' : '0 10px 10px',
    width: '100%'
  };
  return style;
});

const LeftColumn = styled.div((props) => {
  let style = {
    width: !props.isMobile ? widgetWidth : widgetWidthMobile,
    marginRight: !props.isMobile ? 35 : 0,
    marginBottom: !props.isMobile ? 0 : 20
  };
  return style;
});

const RightColumn = styled.div((props) => {
  let style = {
    width: !props.isMobile ? widgetWidth : widgetWidthMobile
  };
  return style;
});

const SuspensionTextDisp = styled.div(() => {
  let style = {
    fontSize: '24px',
    textAlign: 'center',
    color: mediumGrey,
    padding: '40px 48px 0px 40px'
  };
  return style;
});

const UserName = styled.div((props) => {
  let style = {
    width: '100%',
    fontSize: !props.isMobile ? '32px' : '18px',
    fontWeight: '300',
    lineHeight: '36px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginBottom: '15px',
    textAlign: !props.isMobile ? 'left' : 'center',
    paddingTop: !props.isMobile ? '0' : '105px',
    paddingBottom: !props.isMobile ? '0' : '12px',
    backgroundColor: !props.isMobile ? white : dashboardGoalsBackground,
    color: !props.isMobile ? appTextColor : white
  };
  if (props.isMobile) {
    style.backgroundImage = 'url(' + userIcon + ')';
    style.backgroundRepeat = 'no-repeat';
    style.backgroundSize = '80px 80px';
    style.backgroundPosition = 'center 14px';
  }
  return style;
});

const UserEmail = styled.div((props) => {
  let style = {
    width: '100%',
    fontSize: '14px',
    fontWeight: '300',
    lineHeight: '18px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginTop: '10px',
    marginBottom: '10px',
    color: appTextColor
  };
  if (props.isMobile) {
    style.display = 'none';
  }
  return style;
});

const FieldLabel = styled.div(() => {
  let style = {
    display: 'inline-block',
    fontSize: '14px',
    lineHeight: '15px',
    textAlign: 'left',
    fontWeight: 'bold',
    marginTop: '0px',
    marginBottom: '5px',
    color: appTextColor,
    verticalAlign: 'top'
  };
  return style;
});

const FieldErrorDisp = styled.div(() => {
  let style = {
    display: 'block',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 'normal',
    color: warningRedColor,
    marginBottom: '5px',
    width: widgetWidth + 'px'
  };
  if (isRtl) {
    style.textAlign = 'right';
  } else {
    style.textAlign = 'left';
  }
  return style;
});

const RegisterFieldErrorAlert = styled(FieldErrorAlert)((props) => {
  let style = {
    marginTop: '9px'
  };
  // these are pushing it closer to the input, given that
  //  this widget is living in a flex container.
  if (props.isRtl) {
    style.marginLeft = '14px';
  } else {
    style.marginRight = '14px';
  }
  return style;
});

const MenuContainer = styled.div((props) => {
  let style = {
    display: 'block',
    height: widgetHeight + 'px',
    width: !props.isMobile ? widgetWidth : widgetWidthMobile,
    marginBottom: '15px'
  };
  return style;
});

const RegisterUserButton = styled(LaunchpadButton)((props) => {
  let style = {
    paddingLeft: 25,
    paddingRight: 25,
    width: 'auto',
    maxWidth: !props.isMobile ? '210px' : '100%',
    textAlign: 'center'
  };
  if (props.isMobile) {
    style.borderRadius = '4px';
    style.marginTop = '15px';
  }
  return style;
});

const BottomLeftColumn = styled.div(() => {
  let style = {
    width: '315px'
  };
  return style;
});

const TermsCheckboxContainer = styled.div(() => {
  let style = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start'
  };
  return style;
});

const TermsErrorDisp = styled(FieldErrorDisp)(() => {
  let style = {
    width: '100%'
  };
  return style;
});

const TermsCheckbox = styled.input(() => {
  let style = {
    width: '14px',
    height: '14px',
    marginTop: '8px',
    marginBottom: '0px',
    cursor: 'pointer'
  };
  if (isRtl) {
    style.marginLeft = '10px';
    style.marginRight = '0px';
  } else {
    style.marginLeft = '0px';
    style.marginRight = '10px';
  }
  return style;
});

const TermsLabel = styled.label(() => {
  let style = {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '18px',
    maxWidth: '240px',
    cursor: 'pointer',
    '& a': {
      color: blueEnabledColor,
      textDecoration: 'none',
      ':hover': {
        textDecoration: 'underline'
      }
    }
  };
  if (isRtl) {
    style.marginLeft = '10px';
  } else {
    style.marginRight = '10px';
  }
  return style;
});

const ErrorDisp = styled.div((props) => {
  let style = {
    fontSize: '16px',
    lineHeight: '20px',
    textAlign: 'center',
    border: '1px solid ' + warningRedColor,
    borderRadius: '4px',
    color: warningRedColor,
    width: '60%',
    marginLeft: '20%',
    padding: '16px 24px 16px 24px'
  };
  return style;
});

//*********************************************
export class RegisterUser extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tempPassword: '',
      tempPasswordMatch: '',
      selectedVoiceType: '',
      selectedTimezone: '',
      termsAccepted: false,
      validatingPassword: false,
      validatingPasswordMatch: false,
      validatingTerms: false,
      validatingAll: false
    };

    props.setLastTransactionState(TRANSACTION_STATE.NO_TRANSACTION);
    const userId = this.props.match.params.user_guid;

    // ask ego what the rules are about creating passwords in this org
    props.loadPasswordMode({ userId: userId, resetPasswordId: undefined });

    props.initUserRegistration(userId);
  }

  // this is an optimization so we don't have to translate *everything* every time
  //  the page renders, but will still respond when the ui language changes
  localizedToLanguage = '';
  localizedVoiceTypes = [];
  localizedTimezones = [];
  localizedTerms = '';
  localizedButtonLabel = '';
  installLocalizations = () => {
    if (this.props.lionLoaded && this.props.lionLanguage !== this.localizedToLanguage) {
      this.localizedVoiceTypes = voiceTypes.map((voiceType) => {
        return { value: voiceType.value, label: this.props.lionTranslateString(voiceType.labelKey) };
      });
      this.localizedTimezones = timezones.map((timezoneObj) => {
        return { value: timezoneObj.value, label: this.props.lionTranslateString(timezoneObj.labelKey) };
      });
      this.localizedTimezones.sort((zoneOne, zoneTwo) => {
        if (zoneOne.label > zoneTwo.label) {
          return 1;
        }
        if (zoneOne.label < zoneTwo.label) {
          return -1;
        }
        return 0;
      });

      if (this.props.userRegistrationInfo && this.props.userRegistrationInfo.hideTCs) {
        this.localizedButtonLabel = this.props.lionTranslateString('continue');
      } else {
        const lionStr = this.props.lionTranslateString('signup_terms');
        this.localizedTerms = lionStr.replace(/<label for="terms">/g, '');
        this.localizedTerms = this.localizedTerms.replace(/<\/label>/g, '');
        this.localizedTerms = this.localizedTerms.replace('{{terms}}', 'http://www.rosettastone.com/termsonline');
        this.localizedTerms = this.localizedTerms.replace('{{privacy}}','http://www.rosettastone.com/interactiveproductprivacy');
        this.localizedButtonLabel = this.props.lionTranslateString('signup_button_continue');
      }

      this.localizedToLanguage = this.props.lionLanguage;
    }
  };

  handlePasswordChange = (event) => {
    this.setState({
      validatingPassword: true,
      tempPassword: event.target.value
    });
  };
  passwordError = () => {
    if (!this.state.validatingPassword && !this.state.validatingAll) {
      return '';
    }
    return validateUserInfo('newPassword', this.state.tempPassword, '', this.props.passwordMode);
  };

  handlePasswordMatchChange = (event) => {
    this.setState({ tempPasswordMatch: event.target.value });
  };
  // the password match is only validated when the user clicks outside the input
  handlePasswordMatchBlur = (event) => {
    // after the first time they type something in the match, it always validates
    //  even if the field becomes empty - but not the first time if it is empty
    if (!this.state.validatingPasswordMatch && this.state.tempPasswordMatch.length > 0) {
      this.setState({
        validatingPasswordMatch: true
      });
    }
  };
  passwordMatchError = () => {
    if (!this.state.validatingPasswordMatch && !this.state.validatingAll) {
      return '';
    }
    return validateUserInfo('newPasswordMatch', this.state.tempPasswordMatch, this.state.tempPassword);
  };

  handleVoiceTypeSelected = (voicetypeObj) => {
    this.setState({ selectedVoiceType: voicetypeObj.value });
  };
  voiceTypeError = () => {
    if (!this.state.validatingAll) {
      return '';
    }
    return validateUserInfo('voiceType', this.state.selectedVoiceType);
  };

  handleTimezoneSelected = (zoneObj) => {
    this.setState({ selectedTimezone: zoneObj.value });
  };
  timezoneError = () => {
    if (!this.state.validatingAll) {
      return '';
    }
    return validateUserInfo('timezone', this.state.selectedTimezone);
  };

  handleTermsCheckClicked = (event) => {
    this.setState({
      termsAccepted: event.target.checked,
      validatingTerms: true
    });
  };
  termsError = () => {
    if (this.props.userRegistrationInfo.hideTCs || (!this.state.validatingTerms && !this.state.validatingAll)) {
      return '';
    }
    return validateUserInfo('terms', this.state.termsAccepted);
  };

  handleNextButtonClick = (event) => {
    this.setState({
      validatingAll: true
    });
    // calling forceUpdate() so the state gets squared away
    this.forceUpdate(() => {
      if (
        this.passwordError() ||
        this.passwordMatchError() ||
        this.voiceTypeError() ||
        this.timezoneError() ||
        this.termsError()
      ) {
        return;
      }
      const registrationInfo = {
        password: this.state.tempPassword,
        preferences: {
          voiceType: this.state.selectedVoiceType
        },
        timezone: this.state.selectedTimezone
      };
      if (this.props.userRegistrationInfo.hideTCs) {
        registrationInfo.acceptTCs = true;
      }
      this.props.registerUser(this.props.userRegistrationInfo.gui, registrationInfo);
    });
  };

  // ****** render
  render = () => {
    const isMobile = isMobileDetected;

    if (!this.props.lionLoaded) {
      return <MouseCatcher />;
    }
    if (
      this.props.lastTransactionState === TRANSACTION_STATE.PENDING ||
      this.props.loginStatus === LOGIN_STATUS.PENDING
    ) {
      return <MouseCatcher />;
    }
    if (!this.props.passwordMode) {
      return <MouseCatcher />;
    }

    isRtl = this.props.isInterfaceRtl;

    let suspensionDisp = null;
    if (this.props.userRegistrationInfo && this.props.userRegistrationInfo.status === 'suspended_org') {
      suspensionDisp = (
        <SuspensionTextDisp data-qa="SuspensionTextDisp">
          {this.props.lionTranslateString('suspended_org')}
        </SuspensionTextDisp>
      );
    }

    // this is for the overall page error display
    let errorDisp = null;
    if (this.props.lastTransactionState === TRANSACTION_STATE.FAIL) {
      errorDisp = (
        <ErrorDisp data-qa="ErrorDisp">
          {this.props.lionTranslateString('system_error_internal_service_error_(500)')}
        </ErrorDisp>
      );
    }

    let registerWidgets = null;
    if (this.props.userRegistrationInfo && this.props.userRegistrationInfo.status === 'UNREGISTERED') {
      this.installLocalizations();

      let passwordErrorDisp = null;
      const passwordHasError = this.passwordError().length > 0;
      if (passwordHasError) {
        passwordErrorDisp = (
          <FieldErrorDisp data-qa="PasswordError">
            {this.props.lionTranslateString(this.passwordError())}
          </FieldErrorDisp>
        );
      }

      let passwordMatchErrorDisp = null;
      const passwordMatchHasError = this.passwordMatchError().length > 0;
      if (passwordMatchHasError) {
        passwordMatchErrorDisp = (
          <FieldErrorDisp data-qa="PasswordMatchError">
            {this.props.lionTranslateString(this.passwordMatchError())}
          </FieldErrorDisp>
        );
      }

      let voiceTypeErrorDisp = null;
      if (this.voiceTypeError()) {
        voiceTypeErrorDisp = (
          <FieldErrorDisp data-qa="VoiceTypeError">
            {this.props.lionTranslateString(this.voiceTypeError())}
          </FieldErrorDisp>
        );
      }

      let timezoneErrorDisp = null;
      if (this.timezoneError()) {
        timezoneErrorDisp = (
          <FieldErrorDisp data-qa="TimezoneError">
            {this.props.lionTranslateString(this.timezoneError())}
          </FieldErrorDisp>
        );
      }

      let termsCheckbox = null;
      if (!this.props.userRegistrationInfo.hideTCs) {
        let termsErrorDisp = null;
        let termsErrorAlert = null;
        if (this.termsError()) {
          termsErrorDisp = (
            <TermsErrorDisp data-qa="TermsError">{this.props.lionTranslateString(this.termsError())}</TermsErrorDisp>
          );
          termsErrorAlert = <RegisterFieldErrorAlert isRtl={isRtl} />;
        }
        termsCheckbox = (
          <React.Fragment>
            {termsErrorDisp}
            <TermsCheckboxContainer>
              <TermsCheckbox
                type="checkbox"
                id="TermsCheckbox"
                data-qa="TermsCheckbox"
                defaultChecked={this.state.termsAccepted}
                onClick={this.handleTermsCheckClicked}
                tabIndex={6}
              />
              <TermsLabel htmlFor="TermsCheckbox" dangerouslySetInnerHTML={{ __html: this.localizedTerms }} />
              {termsErrorAlert}
            </TermsCheckboxContainer>
          </React.Fragment>
        );
      }

      let successIconUrl = 'url(' + greenCheck + ')';
      const successIconSize = { width: 20, height: 20 };

      let newPasswordSuccessIconUrl = '';
      let newPasswordSuccessIconSize = { width: 0, height: 0 };
      if (this.state.validatingPassword && !passwordHasError) {
        newPasswordSuccessIconUrl = successIconUrl;
        newPasswordSuccessIconSize = successIconSize;
      }
      let matchPasswordSuccessIconUrl = '';
      let matchPasswordSuccessIconSize = { width: 0, height: 0 };
      if (this.state.validatingPasswordMatch && !passwordMatchHasError) {
        matchPasswordSuccessIconUrl = successIconUrl;
        matchPasswordSuccessIconSize = successIconSize;
      }

      let passwordTooltipButton;
      if (!isMobile) {
        let helpKey = 'signup_password_help_text';
        if (this.props.passwordMode === 'strict') {
          helpKey = 'password_strict_requirements';
        }
        passwordTooltipButton = <HelpButton helpTextKey={helpKey} tipPosition={isRtl ? 'left' : 'right'} />;
      }

      registerWidgets = (
        <React.Fragment>
          <TopContainer data-qa="TopContainer" isMobile={isMobile}>
            <UserName data-qa="UserName" isMobile={isMobile}>
              {this.props.userRegistrationInfo.firstName + ' ' + this.props.userRegistrationInfo.lastName}
            </UserName>
            <UserEmail data-qa="UserEmail" isMobile={isMobile}>
              {this.props.userRegistrationInfo.email}
            </UserEmail>
          </TopContainer>
          <MiddleContainer data-qa="MiddleContainer" isMobile={isMobile}>
            <LeftColumn isMobile={isMobile}>
              <FieldLabel data-qa="CreatePasswordTitle">
                {this.props.lionTranslateString('signup_create_password_label')}
              </FieldLabel>
              {passwordTooltipButton}
              {passwordErrorDisp}
              <InputAndAlertContainer
                dataQa="PasswordInputAndAlertContainer"
                displayError={passwordHasError}
                outsideHeight={widgetHeight}
                marginBottom={5}
                inputSideMargin={0}
              >
                <InputWithIcon
                  inputType="password"
                  id="NewPasswordDiv"
                  dataQa="NewPassword"
                  placeholder={this.props.lionTranslateString('signup_password_field_text')}
                  value={this.state.tempPassword}
                  onChange={this.handlePasswordChange}
                  tabIndex={1}
                  autoFocus={true}
                  outsideHeight={widgetHeight}
                  displayError={passwordHasError}
                  specialIconUrl={newPasswordSuccessIconUrl}
                  specialIconSize={newPasswordSuccessIconSize}
                />
              </InputAndAlertContainer>
              {passwordMatchErrorDisp}
              <InputAndAlertContainer
                displayError={passwordMatchHasError}
                outsideHeight={widgetHeight}
                marginBottom={5}
                inputSideMargin={0}
              >
                <InputWithIcon
                  inputType="password"
                  dataQa="NewPasswordMatch"
                  placeholder={this.props.lionTranslateString('signup_repeat_password_field_text')}
                  value={this.state.tempPasswordMatch}
                  onChange={this.handlePasswordMatchChange}
                  onBlur={this.handlePasswordMatchBlur}
                  tabIndex={2}
                  outsideHeight={widgetHeight}
                  displayError={passwordMatchHasError}
                  specialIconUrl={matchPasswordSuccessIconUrl}
                  specialIconSize={matchPasswordSuccessIconSize}
                />
              </InputAndAlertContainer>
            </LeftColumn>
            <RightColumn isMobile={isMobile}>
              <FieldLabel>{this.props.lionTranslateString('signup_voice_type')}</FieldLabel>
              {!isMobile ? (
                <HelpButton data-qa="VoiceTypeHelpButton" helpTextKey="signup_voice_type_help_text" tipPosition="top" />
              ) : null}
              {voiceTypeErrorDisp}
              <MenuContainer isMobile={isMobile}>
                <RSDropdown
                  dataQa="VoiceTypeMenu"
                  buttonText={this.props.lionTranslateString('signup_dropdown_select_text')}
                  itemsList={this.localizedVoiceTypes}
                  itemDisplayProperty="label"
                  itemKeyProperty="value"
                  onSelectionHandler={this.handleVoiceTypeSelected}
                  selectedKey={this.state.selectedVoiceType}
                  menuTabIndex={4}
                  isRtl={isRtl}
                  menuStyle={menuStyle}
                />
              </MenuContainer>

              <FieldLabel>{this.props.lionTranslateString('signup_time_zone_selection')}</FieldLabel>
              {!isMobile ? (
                <HelpButton data-qa="TimezoneHelpButton" helpTextKey="signup_time_zone_help_text" tipPosition="top" />
              ) : null}
              {timezoneErrorDisp}
              <MenuContainer isMobile={isMobile}>
                <RSDropdown
                  dataQa="TimeZoneMenu"
                  buttonText={this.props.lionTranslateString('signup_dropdown_select_text')}
                  itemsList={this.localizedTimezones}
                  itemDisplayProperty="label"
                  itemKeyProperty="value"
                  onSelectionHandler={this.handleTimezoneSelected}
                  selectedKey={this.state.selectedTimezone}
                  menuTabIndex={5}
                  isRtl={isRtl}
                  menuStyle={menuStyle}
                />
              </MenuContainer>
            </RightColumn>
          </MiddleContainer>
          <BottomContainer data-qa="BottomContainer" isMobile={isMobile}>
            <BottomLeftColumn>{termsCheckbox}</BottomLeftColumn>
            <RegisterUserButton data-qa="RegisterUserButton" onClick={this.handleNextButtonClick} isMobile={isMobile}>
              {this.localizedButtonLabel}
            </RegisterUserButton>
          </BottomContainer>
        </React.Fragment>
      );
    }

    return (
      <RegisterUserDiv data-qa="RegisterUser" isMobile={isMobile}>
        {/* event will be sent after user authenticates */}
        <EndInteraction interaction="application-startup" />
        <RegisterUserBox isMobile={isMobile}>
          {errorDisp}
          {suspensionDisp}
          {registerWidgets}
        </RegisterUserBox>
      </RegisterUserDiv>
    );
  };
}

RegisterUser.propTypes = {};

const mapStateToProps = (state, ownprops) => ({
  isInterfaceRtl: appSelectors.isInterfaceRtl(state),
  lionLanguage: lionSelectors.getLionLanguage(state),
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  },
  lastTransactionState: appSelectors.lastTransactionState(state),
  userRegistrationInfo: registerSelectors.userRegistrationInfo(state),
  loginStatus: authSelectors.loginStatus(state),
  passwordMode: passwordChangeSelectors.getPasswordMode(state)
});

const wrapActions = {
  setLastTransactionState: appActions.setLastTransactionState,
  initUserRegistration: registerActions.initUserRegistration,
  registerUser: registerActions.registerUser,
  loadPasswordMode: passwordChangeActions.loadPasswordMode
};

export const RegisterUserContainer = connect(
  mapStateToProps,
  wrapActions
)(withWindowDimensions(RegisterUser));



// WEBPACK FOOTER //
// ./src/modules/register/components/RegisterUser.jsx